import { ImageModel } from './image-model.interface';
import { OrderTrackingRequest } from './orderTracking';
import { ProductDisplay } from './product-display.interface';

export class ProductInformation {
    sku: String;
    productDescription: String;
    unitPrice: number;
    quantity: number;
    cc: number;
    price: number;
    itemNumber:string;
    productName:string;
    unitPaidPrice:number;
    totalPaidPrice:number;
    comboBOMEnabled: boolean;
}


export interface Product {
    id: number;
    name: string;
    displayName: string;
    shortDescription: string;
    attributes: any[];
    autoshipEnabled: boolean;
    slug: string;
    longDescription: string;
    retailPrice: number;
    wholesalePrice: number;
    applicablePrice: number;
    catalogPrice: number;
    commissionableVolume: number;
    itemNumber: string;
    noOfReviews: number;
    sku: string;
    uniqueProductId: string;
    ratingDisplayed: boolean;
    virtualProduct: boolean;
    downloadableProduct: boolean;
    stockAvailable: boolean;
    overAllRating: number;
    stockQuantity?: number;
    manageStock?: boolean;
    wishListItem: boolean;
    images: any[];
    productTypeMasterId: number;
    quantity: number;
    productPurchaseFlowModelList: any[];
    // these properties are added by us
    productQuantity?: number;
    disableDecrement: boolean;
    revisionNumber?: string;
    importedMeasurementUnit?: string;
    discountPercentage?: number;
    priceTierName?: string;
    customCatalogName: string;
    customCatalogId: number;
    selectedOption: string;
    parentProductSlug: string;
    meta; ProductSEOMetaData;
    isPromotionalProduct: boolean;
    productMetaData?: ProductMetaData[];
    literature: boolean;
    imageModelList?: ImageModel[];
    productId?: number;
    taxRate?: number;
    display?: ProductDisplay;
    isFeaturedPak?: boolean;
    isFBOEligibleProduct?: boolean;
    isFreeProductEligible?: boolean;
    optionCombinationValues?: any;
    options?: any;
    computedComboTaxTotals: any[];
    promoProduct: boolean;
    orderPromotionTrackings?: OrderTrackingRequest[];
    associateProductId?: number;
}

export interface ProductMetaData {
    productID: number;
    metaTitle: string;
    metaKeyWords: string;
}
export class ProductDisputeInfo {
    id?: number;
    itemNumber?: string;
    productDescription?: string;
    quantity?: number;
    alreadyDisputedQuantity?: number;
    newDisputedQuantity?: number;
    productDisputeReason?: string;

}

export interface ProductAssociation {
    productId: number;
    depositFeeProductId: number;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/product-info.ts